import React from "react";
import { PARTNERS } from "../../../constant/CarouselData";
import SectionHeader from "../../HomeDetailSection/SectionHeader";

// The marquee needs the list twice so the scroll loops seamlessly. Only the
// first pass is exposed to assistive tech — the duplicate is decoration.
//
// Every source logo in public/assets/partners is also saved as a resized .webp
// (the PNGs stay on disk as the source of truth — some were absurdly oversized
// for an 80px marquee tile, e.g. intel.png shipped at 294KB for a 160px logo).
// .webp is what actually loads here.
//
// These live under public/ and are referenced by URL rather than imported. A
// require() with a template literal in it cannot be resolved statically, so
// webpack answers it by bundling the *entire* directory into the entry chunk —
// all 88 files, both formats. Every logo under CRA's 10KB inline threshold then
// became a base64 data URI inside main.js: 91KB of image bytes, in the one file
// that blocks first paint, that gzip cannot compress because they are already
// compressed. The `loading="lazy"` below was silently doing nothing as a
// result — the bytes had already arrived before the first pixel was painted.
const LOGO_DIR = "/assets/partners";
const toWebp = (name) => name.replace(/\.(png|jpe?g)$/i, ".webp");

const LOGOS = PARTNERS.map((tech) => ({
  name: tech.name,
  src: `${LOGO_DIR}/${tech.imageUrl ? toWebp(tech.imageUrl) : "cisco.webp"}`,
}));

const BrandPartners = () => (
  <section className="bg-white py-8">
    <div className="mx-auto max-w-[88rem] px-4 sm:px-6">
      <SectionHeader
        title="Brands we supply"
        subtitle={`Authorised and channel-sourced hardware from ${PARTNERS.length}+ manufacturers`}
      />
    </div>

    <div className="relative overflow-hidden">
      <div className="animate-scroll flex items-center gap-6">
        {[0, 1].map((pass) =>
          LOGOS.map((logo) => (
            <div
              key={`${pass}-${logo.name}`}
              className="flex-shrink-0 rounded-lg bg-white px-4 py-2"
              {...(pass === 1 ? { "aria-hidden": "true" } : {})}
            >
              {/* The square lives on this box, not on the <img>. Sizing the
                  image itself `h-20 w-20` made every logo's rendered box a
                  square, which almost none of them are — the CyberPower
                  wordmark is 160x42. object-contain kept it looking right, but
                  the measured display ratio still disagreed with the file's,
                  and that mismatch is what image aspect-ratio audits report.
                  Capping the image instead lets each logo render at its own
                  ratio inside the same reserved space. */}
              <div className="flex h-20 w-20 items-center justify-center sm:h-24 sm:w-24">
                <img
                  src={logo.src}
                  alt={pass === 0 ? logo.name : ""}
                  // No width/height attributes: each manufacturer logo has its
                  // own natural ratio, so one hardcoded pair would misreport 87
                  // of the 88. The box above already reserves the space.
                  // 88 logos render here; without lazy-loading they'd all
                  // download on load and dominate the homepage's transfer
                  // weight.
                  loading="lazy"
                  decoding="async"
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  </section>
);

export default BrandPartners;
